import React, {useState, useEffect} from 'react'

import BrassPanel from '../../../components/BrassPanel'
import settings from './machineSettingsData'

function MachineLightMatrix({lightIndex, variation, overheating, resetGame}) {
    const [display, setDisplay] = useState(0)
    const [fontColor, setFontColor] = useState({
        on: 'lightseagreen',
        off: 'darkgray'
    })
    const [lightCombinations] = useState(settings.lightCombos)
    
    useEffect(() => {
        if (overheating) {
            setTimeout(() => {
                if (fontColor.off === 'darkgray') {
                    setFontColor({
                        on: 'firebrick',
                        off: 'firebrick'
                    })
                } else {
                    setFontColor({
                        on: 'darkgray',
                        off: 'darkgray'
                    })
                }
            }, 250)
        } else {
            if (fontColor.on !== 'lightseagreen') {
                setFontColor({
                    on: 'lightseagreen',
                    off: 'darkgray'
                })
            } 
        }
    }, [overheating, fontColor])
    
    useEffect(() => {
        if (!resetGame) {
            lightIndex && setDisplay(lightIndex[variation])
        } else {
            setDisplay(0)
        }
    }, [lightIndex, resetGame, variation])
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-lightMatrix'>
            <div className='machine_lightIndicatorsContainer'>
                {lightCombinations[display].map((light, index) => {
                    return (
                        <i
                            key={index}
                            className="
                                fas 
                                fa-radiation-alt 
                                machine_lightIndicator
                            "
                            style={{
                                fontSize: '2rem', 
                                color: light === 1 ? fontColor.on : fontColor.off,
                                opacity: light !== 1 && '.75',
                                filter: light === 1 && !overheating ? 
                                    'drop-shadow(0 0 2px darkseagreen)' :
                                    'drop-shadow(2px 2px 5px black)'
                            }}
                        ></i>
                    )
                    
                })}
            </div>
        </BrassPanel>
    )
}

export default MachineLightMatrix